<template>
  <v-autocomplete :value="value" @input="$emit('input', $event)" :items="filteredListDiscipline"
    item-text="descr" item-value="idDisciplina" :disabled="disabled"
    :menu-props="{ maxHeight: '400', maxWidth: '1000', contentClass: 'discipline-picker-menu' }"
    :label="label || $t('pick_your_disciplines')" multiple chips color="primary"
    :hint="hint || $t('pick_your_disciplines')" :persistent-hint="persistentHint">
    <template v-slot:prepend-item>
      <div class="discipline-filter-sticky">
        <v-list-item @click.stop class="primary discipline-filter-bar">
          <v-row dense align="center" class="px-2">
            <v-col md="1" cols="12" class="text-center">
              <v-btn icon dark @click.stop="toggleSelectAllFiltered">
                <v-icon>{{ allFilteredSelected ? 'mdi-checkbox-multiple-marked-outline' : 'mdi-checkbox-multiple-blank-outline' }}</v-icon>
              </v-btn>
            </v-col>
            <v-col md="4" cols="12">
              <v-text-field v-model="search" clearable dense dark prepend-inner-icon="mdi-magnify"
                :label="$t('search_by_name')" hide-details="auto" @click.stop></v-text-field>
            </v-col>
            <v-col md="7" cols="12">
              <v-btn-toggle v-model="filterConi" mandatory dense class="primary darken-1">
                <v-btn value="all" :color="filterConi === 'all' ? 'success' : undefined">{{ $t("all_f_p") }}</v-btn>
                <v-btn value="coni" :color="filterConi === 'coni' ? 'success' : undefined">{{ $t("recognized_by_CONI") }}</v-btn>
                <v-btn value="noConi" :color="filterConi === 'noConi' ? 'success' : undefined">{{ $t("not_recognized_by_CONI") }}</v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
        </v-list-item>
        <v-divider></v-divider>
      </div>
    </template>
    <template v-slot:item="{ item, attrs, on }">
      <v-list-item v-on="on" v-bind="attrs">
        <v-list-item-action>
          <v-checkbox :input-value="attrs.inputValue" readonly color="primary" hide-details dense></v-checkbox>
        </v-list-item-action>
        <v-list-item-avatar v-if="item.ifCONI === 1 && item.code_LIBERTAS" size="32">
          <v-img src="/img/logo-libertas.png" alt="Libertas" contain max-width="28" height="28"></v-img>
        </v-list-item-avatar>
        <v-list-item-content
          :class="{ 'discipline-item-content--without-logo': !(item.ifCONI === 1 && item.code_LIBERTAS) }">
          <v-list-item-title>{{ item.descr }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-slot:selection="{ item }">
      <v-chip small class="mr-1 discipline-chip"
        :class="{ 'discipline-chip--without-logo': !(item.ifCONI === 1 && item.code_LIBERTAS) }">
        <v-avatar v-if="item.ifCONI === 1 && item.code_LIBERTAS" size="20" class="mr-1">
          <v-img src="/img/logo-libertas.png" alt="Libertas" contain max-width="20" height="20"></v-img>
        </v-avatar>
        {{ item.descr }}
      </v-chip>
    </template>
  </v-autocomplete>
</template>
<script>
export default {
  name: "discipline-picker",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: null,
    },
    persistentHint: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      listDiscipline: [],
      search: null,
      filterConi: "all",
    };
  },
  computed: {
    filteredListDiscipline() {
      let _ = this;
      let search = (_.search || "").trim().toLowerCase();
      return _.listDiscipline.filter((discipline) => {
        // keep already selected items visible even if they don't match current filters
        if (_.value && _.value.includes(discipline.idDisciplina)) return true;
        if (_.filterConi === "coni" && discipline.ifCONI !== 1) return false;
        if (_.filterConi === "noConi" && discipline.ifCONI === 1) return false;
        if (search && !String(discipline.descr || "").toLowerCase().includes(search)) return false;
        return true;
      });
    },
    allFilteredSelected() {
      let _ = this;
      return (
        _.filteredListDiscipline.length > 0 &&
        _.filteredListDiscipline.every((discipline) => _.value && _.value.includes(discipline.idDisciplina))
      );
    },
  },
  methods: {
    toggleSelectAllFiltered() {
      let _ = this;
      let filteredIds = _.filteredListDiscipline.map((discipline) => discipline.idDisciplina);
      let newValue = _.allFilteredSelected
        ? (_.value || []).filter((id) => !filteredIds.includes(id))
        : Array.from(new Set([...(_.value || []), ...filteredIds]));
      _.$emit("input", newValue);
    },
    loadData() {
      let _ = this;
      _.listDiscipline = [];
      _.chiamataAxios("GET", "/auth/ente/listAllDiscipline").then((response) => {
        _.listDiscipline = response.data;
      });
    },
  },
  created() {
    this.loadData();
  },
};
</script>
<style scoped>
.discipline-filter-sticky {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: var(--v-primary-base);
}

.discipline-picker-menu .v-select-list {
  padding: 0 !important
}

.discipline-filter-bar {
  border-radius: 4px;
  opacity: 1 !important;
  background-color: var(--v-primary-base) !important;
}

.discipline-item-content--without-logo {
  padding-left: 30px;
}

.discipline-chip--without-logo {
  padding-left: 10px;
}

.discipline-chip:not(.discipline-chip--without-logo) {
  padding-left: 0;
}

.discipline-chip .v-avatar {
  margin-left: 0;
}
</style>
